import React from "react";

const ErrorComponent = ({ message = "Oops! Something went wrong.", onRetry, showRetry = true }) => {
  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0%, 100% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.05); opacity: 0.8; }
          }
          
          .error-button:hover {
            transform: translateY(-2px) !important;
            box-shadow: 0 15px 35px rgba(139, 195, 74, 0.5) !important;
          }
          
          .error-button:active {
            transform: translateY(0) !important;
          }
          
          .error-card:hover {
            transform: translateY(-5px) !important;
            box-shadow: 0 35px 60px rgba(139, 195, 74, 0.25), 0 0 0 1px rgba(220, 237, 200, 0.8) !important;
          }
          
          @media (max-width: 480px) {
            .error-card {
              margin: 1rem;
              padding: 2rem 1.5rem !important;
            }
          }
        `}
      </style>
      
      <div style={styles.wrapper}>
        <div style={styles.card} className="error-card">
          <div style={styles.icon}>⚠️</div>
          <h2 style={styles.title}>Error</h2>
          <p style={styles.message}>{message}</p>
          {showRetry && onRetry && (
            <button 
              style={styles.button} 
              className="error-button"
              onClick={onRetry}
            >
              🔄 Retry
            </button>
          )}
        </div>
      </div>
    </>
  );
};

const styles = {
  wrapper: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #fef9e7 0%, #f0f8e7 50%, #e8f5e8 100%)",
    padding: "1rem",
    position: "relative",
    overflow: "hidden",
  },
  card: {
    padding: "3rem 2.5rem",
    background: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(20px)",
    borderRadius: "24px",
    boxShadow: "0 25px 50px rgba(139, 195, 74, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.4)",
    maxWidth: "450px",
    width: "100%",
    textAlign: "center",
    border: "1px solid rgba(220, 237, 200, 0.6)",
    position: "relative",
    transform: "translateY(0)",
    transition: "all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)",
  },
  icon: {
    fontSize: "4rem",
    marginBottom: "1.5rem",
    filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))",
    animation: "pulse 2s infinite",
  },
  title: {
    fontSize: "2.2rem",
    fontWeight: "700",
    background: "linear-gradient(135deg, #f39c12, #d4b106)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    marginBottom: "0.8rem",
    letterSpacing: "-0.02em",
  },
  message: {
    color: "#5d7c47",
    fontSize: "1.1rem",
    lineHeight: "1.6",
    marginBottom: "2rem",
    fontWeight: "400",
  },
  button: {
    padding: "0.875rem 2rem",
    background: "linear-gradient(135deg, #8bc34a, #689f38)",
    color: "#fff",
    border: "none",
    borderRadius: "50px",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)",
    boxShadow: "0 10px 25px rgba(139, 195, 74, 0.4)",
    position: "relative",
    overflow: "hidden",
  },
};

export default ErrorComponent;